import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import customerService from '../../services/customerService';
import { CUSTOMER_RECHARGE_ACTIONS } from '../../constant/stringConstant';

export const fetchCustomerList = createAsyncThunk<
  any[],
  { search: string; plantId: string },
  { rejectValue: string }
>(
  CUSTOMER_RECHARGE_ACTIONS.FETCH_CUSTOMER_LIST,
  async ({ search, plantId }, { rejectWithValue }) => {
    try {
      const res = await customerService.getCustomerList(search, plantId);
      return res;
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface FetchCustomerListState {
  customerList: any[];
  loading: boolean;
  error: string | null;
}

const initialState: FetchCustomerListState = {
  customerList: [],
  loading: false,
  error: null,
};

const fetchCustomerListSlice = createSlice({
  name: 'fetchCustomerList',
  initialState,
  reducers: {
    resetCustomerList: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        state.customerList = action.payload;
      })
      .addCase(fetchCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
      });
  },
});

export const { resetCustomerList } = fetchCustomerListSlice.actions;
export default fetchCustomerListSlice.reducer;
